import { BREAKPOINTS } from "../Constants/breakpoints"

export class HubspotForm {
    private hsForm: HTMLElement | null = null;
    private formContainer: HTMLElement | null = null;
    private observer: MutationObserver | null = null;

    constructor() {
        this.init();
    };

    private init(): void {
        this.waitForHubSpotForm().then(() => {
            this.setupAprimoConversionTrackingAttributes();
            this.setupFormScrolling();
        });
    };

    private waitForHubSpotForm(): Promise<void> {
        return new Promise((resolve) => {
            if (this.findFormElements()) {
                resolve();
                return;
            }

            const observer = new MutationObserver((mutations) => {
                for (const mutation of mutations) {
                    if (mutation.type === "childList") {
                        if (this.findFormElements()) {
                            observer.disconnect();
                            resolve();
                            return;
                        }
                    }
                }
            })

            observer.observe(document.body, {
                childList: true,
                subtree: true
            })

            setTimeout(() => {
                observer.disconnect();
                if (this.findFormElements()) {
                    resolve();
                }
            }, 10000);
        })
    };

    private findFormElements(): boolean {
        this.hsForm = document.querySelector(".hs-form");
        this.formContainer = document.querySelector(".contact-form-container");
        return !!(this.hsForm && this.formContainer);
    };

    private setupAprimoConversionTrackingAttributes(): void {
        if (!this.hsForm || !this.formContainer) return;

        const containerConversion = this.formContainer.getAttribute("data-aprimo-conversion")?.trim();
        if (containerConversion) {
            this.hsForm.setAttribute("data-aprimo-conversion", containerConversion);
            return;
        }

        const isDemo =
            window.location.pathname.toLowerCase().includes("demo") ||
            !!document.querySelector('[data-aprimo-conversion="demo-request-form-submit"]');

        const conversionType = isDemo ? "demo-request-form-submit" : "contact-us-form-submit";
        this.hsForm.setAttribute("data-aprimo-conversion", conversionType);
    }

    private setupFormScrolling(): void {
        if (!this.hsForm || !this.formContainer) return;

        this.observer = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
                if (mutation.type === "childList") {
                    const hasSubmissionMessage = this.formContainer?.querySelector('.submitted-message');

                    if (hasSubmissionMessage) {
                        this.formContainer?.scrollIntoView({
                            behavior: 'smooth',
                            block: 'center'
                        });
                    }
                }
            }
        });

        this.observer.observe(this.formContainer, {
            childList: true,
            subtree: true
        });
    };
}

document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('.hbspt-form')) {
        new HubspotForm();
    }
});